import { Loader2 } from 'lucide-react'

interface Props {
  label?: string
  className?: string
}

export function LoadingSpinner({ label = 'Loading…', className }: Props) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-12 text-muted-foreground ${className ?? ''}`}>
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
      <p className="text-sm">{label}</p>
    </div>
  )
}
